import React from 'react';
import {Form, Checkbox} from 'antd';

const FormItem = Form.Item;

const TargetExtends = ({actionDisable, value, handleChange}) => (
    <FormItem label="指标扩展内容">
        <Checkbox
        disabled={actionDisable}
        checked={ value != null && value.indexOf("kaoqingon") !== -1 ? true : false}
        onChange={(event) => {
                const targetExtends = event.target.checked ? 'kaoqingon': 'kaoqingoff';
                handleChange({targetExtends});
                }}></Checkbox>考勤记录
        <Checkbox
        disabled={actionDisable}
        checked={value != null && value.indexOf("tingkeon") !== -1 ? true : false}
        onChange={(event) => {
                const targetExtends = event.target.checked ? 'tingkeon': 'tingkeoff';
                handleChange({targetExtends});
                }}></Checkbox>听课情况
    </FormItem>
);

export default TargetExtends;
